import { create } from "zustand";

type QrPopupStore = {
  open: boolean;
  openPopup: () => void;
  closePopup: () => void;
};

export const useQrPopupStore = create<QrPopupStore>((set) => ({
  open: false,
  openPopup: () => set({ open: true }),
  closePopup: () => set({ open: false }),
}));
